import "dayjs/locale/en-gb";
import "dayjs/locale/en-au";
import "dayjs/locale/en";
import "dayjs/locale/ja";

import dayjs from "dayjs";
import localeDate from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";

const userLocale =
  navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language || "en-AU";

dayjs.locale(userLocale?.toLowerCase() || "en-au");

dayjs.extend(localeDate);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
